const ENV = process.env;

export const DEV = ENV.REACT_APP_DEVELOPMENT === "1";
